<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import cloneDeep from "lodash/cloneDeep";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Employee from "@/components/modals/employee-hris";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
  page: {
    title: "Transfer Request"
  },
  components: {
    Layout,
    PageHeader,
    Employee,
    PrintOptions
  },
  data() {
    return {
      title: "Transfer Request",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Transfer Request",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Transfer Request",
          tdClass: "align-middle"
        }
      ],
      transferItems: [],
      currentPageItems: 1,
      propertyBackup: {},
      indexSelected: -1,
      tableBusy: false,
      updateForm: {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: ""
      },
      loading: false,
      tabIndex: 0,
      itemIndex: -1,
      selectedCampus: null,
      campusId: this.$store.state.data.selectedCampus.id
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.propertyTransferNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          )
            return item.propertyTransferNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          if (
            item.fromEmployee.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.fromEmployee
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          if (
            item.transferToEmployee
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          )
            return item.transferToEmployee
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
  },
  methods: {
    changeCampus(data) {
      this.selectedCampus = data.id;
      if (this.tabIndex == 0) {
        this.getPosted();
      } else if (this.tabIndex == 1) {
        this.getApprpoved();
      }
    },
    getPosted() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertytransfer/GetPropertyTransferPostedByCampus",
          this.selectedCampus
        )
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting disposal list!",
            "error"
          );
        });
    },
    getApprpoved() {
      this.tableBusy = true;
      this.$store
        .dispatch(
          "propertytransfer/GetPropertyTransferApprovedtByCampus",
          this.selectedCampus
        )
        .then((res) => {
          this.tableBusy = false;
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting disposal list!",
            "error"
          );
        });
    },
    showTransfer(row) {
      this.transferItems = row.propertyTransferItems;
      this.modalTitle = "Transfer Items";
      this.$bvModal.show("modal-transferItems");
    },
    onUpdate() {
      this.submitted = true;
      if (this.checkUpdateForm()) {
        this.showPermanentToast(
          "There are fields that require your attention.",
          "error"
        );
        return;
      } else {
        this.$store
          .dispatch("propertytransfer/UpdatePropertyTransfer", this.updateForm)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.tableData.splice(this.itemIndex, 1, this.updateForm);
            this.showToast("Successfully updated!", "success");
            this.onReset();
            this.$bvModal.hide("modal-update");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Updating this request!",
              "error"
            );
          });
        this.submitted = false;
      }
    },
    updateItem(row) {
      this.onReset();
      this.itemIndex = this.tableData.findIndex((item) => item.id == row.id);
      this.updateForm = cloneDeep(row);
      this.modalTitle = "Update Request";
      this.$bvModal.show("modal-update");
    },
    deleteItem(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertytransfer/DeletePropertyTransfer", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex(
                (item) => item.id == row.id
              );
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    returnItem(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to return this as draft.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertytransfer/ReturnPropertyTransfer", row.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var itemIndex = this.tableData.findIndex(
                (item) => item.id == row.id
              );
              this.tableData.splice(itemIndex, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    async approveTransfer(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to approve this transfer.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, approve it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertytransfer/ApprovePropertyTransfer", id)
            .then((res) => {
              this.tableData.splice(this.itemIndex, 1);
              this.showToast("Successfully Approved!", "success");
            });
        }
      });
    },
    onReset() {
      this.updateForm = {
        propertyAssignmentId: null,
        type: "",
        reason: "",
        transferToEmployeeId: null,
        remarks: ""
      };
      this.itemIndex = -1;
      this.submitted = false;
    },
    checkUpdateForm() {
      if (
        this.updateForm.transferToEmployeeId == null ||
        this.updateForm.transferToEmployeeId == "" ||
        this.updateForm.type == null ||
        this.updateForm.type == "" ||
        this.updateForm.reason == null ||
        this.updateForm.reason == ""
      )
        return true;
    },
    getEmployee() {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
    },
    async dropEmployee(data) {
      var firstname = data.firstName;
      var middleName = data.middleName.charAt(0);
      var lastname = data.lastName;
      this.updateForm.transferToEmployeeId = data.idNo;
      this.updateForm.transferToEmployee = firstname.concat(
        " ",
        middleName,
        ". ",
        lastname
      );
    },
    async printPropertyTransfer(id) {
      var apiUrl = `api/Report/Property/Transfer`;
      var routeVariables = [id];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    }
  }
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- Transfer Items -->
    <b-modal
      id="modal-transferItems"
      :title="modalTitle"
      size="lg"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div class="custom-table-responsive mb-0 mt-2">
        <b-table
          class="datatables target-table"
          thead-class="d-none"
          :items="transferItems"
          :fields="fields"
          responsive="sm"
          per-page="5"
          :current-page="currentPageItems"
          :sort-by.sync="sortBy"
          sort-desc
          bordered
          outlined
          striped
          show-empty
        >
          <template #empty>
            <div class="text-center">
              <div>
                <i class="fas fa-exclamation-triangle me-2"></i>No properties
                available
              </div>
            </div>
          </template>
          <template #cell(id)="row">
            <div class="text-white">{{ row.item.propertyName }}</div>
            <small>Property Number: {{ row.item.propertyNumber }}</small>
            <br />
            <small
              >{{ row.item.amount >= 50000 ? "PAR" : "ICS" }} Number:
              {{ row.item.assignmentNumber }}</small
            >
          </template>
        </b-table>
      </div>
      <div class="row">
        <div v-if="transferItems.length > 0" class="col">
          Showing {{ (currentPageItems - 1) * 5 + 1 }} -
          {{
            transferItems.length > (currentPageItems - 1) * 5 + 5
              ? (currentPageItems - 1) * 5 + 5
              : transferItems.length
          }}
          of {{ transferItems.length }}
        </div>
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
              <!-- pagination -->
              <b-pagination
                v-model="currentPageItems"
                :total-rows="transferItems.length"
                :per-page="5"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Update Request -->
    <b-modal
      id="modal-update"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onUpdate" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="employee">Employee</label>
          <b-input-group>
            <template #append>
              <b-button @click="getEmployee('update')" variant="outline-info"
                ><i class="mdi mdi-clipboard-text-search-outline"></i
              ></b-button>
            </template>
            <input
              autocomplete="off"
              type="text"
              disabled
              placeholder="Search Employee..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (updateForm.transferToEmployeeId == null ||
                    updateForm.transferToEmployeeId == '')
              }"
              v-model="updateForm.transferToEmployee"
            />
          </b-input-group>
          <div
            v-if="
              submitted &&
                (updateForm.transferToEmployeeId == null ||
                  updateForm.transferToEmployeeId == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="assignmentType">Assignment Type </label>
          <b-form-select
            class="form-select"
            :class="{
              'is-invalid':
                submitted && (updateForm.type == null || updateForm.type == '')
            }"
            v-model="updateForm.type"
          >
            <b-form-select-option value="" disabled
              >Select Type...</b-form-select-option
            >
            <b-form-select-option value="New">New</b-form-select-option>
            <b-form-select-option value="Donation"
              >Donation</b-form-select-option
            >
            <b-form-select-option value="Reassignment"
              >Reassignment</b-form-select-option
            >
            <b-form-select-option value="Relocate"
              >Relocate</b-form-select-option
            >
            <b-form-select-option value="Others">Others</b-form-select-option>
          </b-form-select>
          <div
            v-if="
              submitted && (updateForm.type == null || updateForm.type == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="reason">Reason</label>
          <textarea
            id="reason"
            rows="2"
            v-model="updateForm.reason"
            placeholder="Enter Reason..."
            class="form-control"
            :class="{
              'is-invalid':
                submitted &&
                (updateForm.reason == null || updateForm.reason == '')
            }"
            autocomplete="off"
          ></textarea>
          <div
            v-if="
              submitted &&
                (updateForm.reason == null || updateForm.reason == '')
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Update</button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <b-tabs
      content-class="pt-3 pb-3 text-muted"
      v-model="tabIndex"
      nav-class="nav-tabs-custom"
    >
      <b-tab @click="getPosted()">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-cancel"></i>
          </span>
          <span class="d-none d-sm-inline-block">Posted</span>
        </template>
        <div
          v-if="tabIndex == 0"
          class="card border-4 border-top border-start-0 border-end-0 border-primary"
        >
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Posted Request</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        @input="currentPage = 1"
                        placeholder="Search Request..."
                        class="form-control"
                      ></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select
                        class="form-select"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      >
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table
                class="datatables target-table"
                :items="filtered"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div v-if="filter != ''">
                      <i class="fas fa-exclamation-triangle me-2"></i>There are
                      no properties matching your request
                    </div>
                    <div v-else>
                      <i class="fas fa-exclamation-triangle me-2"></i>No
                      properties available
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(id)="row">
                  <div class="d-flex justify-content-between">
                    <div>
                      <div class="text-white">
                        From: {{ row.item.fromEmployee }}
                      </div>
                      <div class="text-white">
                        To: {{ row.item.transferToEmployee }}
                      </div>
                      <small class="d-flex align-items-center"
                        >Transfer#
                        {{ row.item.propertyTransferNumber }}
                        <span class="ms-2">
                          |
                          <a
                            href="javascript: void(0);"
                            class="ms-1"
                            @click="showTransfer(row.item)"
                          >
                            Show Items
                          </a>
                        </span>
                      </small>
                    </div>
                    <div
                      class="d-flex justify-content-between"
                      style="width: 45%;"
                    >
                      <div>
                        <b>Reason:</b>
                        <div>{{ row.item.reason }}</div>
                      </div>
                      <div>
                        <div class="gap-2 d-flex align-items-center">
                          <!-- <a title="Return to Draft" href="javascript:void(0);" class="text-warning me-1"
                            @click="returnItem(row.item)"><i class="mdi mdi-undo-variant fs-4"></i></a> -->
                          <a
                            title="Print Property Transfer"
                            href="javascript:void(0);"
                            @click="printPropertyTransfer(row.item.id)"
                            ><i class="bx bx-printer fs-4"></i
                          ></a>
                          <a
                            title="Delete"
                            href="javascript:void(0);"
                            class="text-danger"
                            @click="deleteItem(row.item)"
                            ><i class="bx bx-trash fs-4"></i
                          ></a>
                          <a
                            title="Update"
                            href="javascript:void(0);"
                            class="text-info"
                            @click="updateItem(row.item)"
                            ><i class="bx bx-edit-alt fs-4"></i
                          ></a>
                          <a
                            title="Assign to Accountable Officer"
                            href="javascript:void(0);"
                            class="text-success"
                            @click="approveTransfer(row.item.id)"
                            ><i class="bx bx-check-circle fs-3"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab @click="getApprpoved()">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-cancel"></i>
          </span>
          <span class="d-none d-sm-inline-block">Completed</span>
        </template>
        <div
          v-if="tabIndex == 1"
          class="card border-4 border-top border-start-0 border-end-0 border-primary"
        >
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">List of Completed Request</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        @input="currentPage = 1"
                        placeholder="Search Request..."
                        class="form-control"
                      ></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select
                        class="form-select"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      >
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table
                class="datatables target-table"
                :items="filtered"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div v-if="filter != ''">
                      <i class="fas fa-exclamation-triangle me-2"></i>There are
                      no properties matching your request
                    </div>
                    <div v-else>
                      <i class="fas fa-exclamation-triangle me-2"></i>No
                      properties available
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(id)="row">
                  <div class="d-flex justify-content-between">
                    <div>
                      <div class="text-white">
                        From: {{ row.item.fromEmployee }}
                      </div>
                      <div class="text-white">
                        To: {{ row.item.transferToEmployee }}
                      </div>
                      <small class="d-flex align-items-center"
                        >Transfer#
                        {{ row.item.propertyTransferNumber }}
                        <span class="ms-2">
                          |
                          <a
                            href="javascript: void(0);"
                            class="ms-1"
                            @click="showTransfer(row.item)"
                          >
                            Show Items
                          </a>
                        </span>
                      </small>
                    </div>
                    <div
                      class="d-flex justify-content-between"
                      style="width: 45%;"
                    >
                      <div>
                        <b>Reason:</b>
                        <div>{{ row.item.reason }}</div>
                      </div>
                      <div class="text-center">
                        <a
                          title="Print Property Transfer"
                          href="javascript:void(0);"
                          @click="printPropertyTransfer(row.item.id)"
                          ><i class="bx bx-printer fs-4"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.slideUp-enter-active {
  animation: slide-up 0.5s;
}

.slideUp-leave-active {
  animation: slide-up 0.5s reverse;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    transform: translateY(-30px);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
